const canUseMedia = !!(typeof window !== 'undefined' && window.matchMedia)

export default canUseMedia
